module.exports = __webpack_public_path__ + "static/img/bronze 3.40eef93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 3.png
// module id = 3idz
// module chunks = 35